import React, { useEffect, useState } from 'react';
import { TextField, Paper, Toolbar, AppBar, Button, Typography, FormControl, InputLabel, MenuItem, Divider } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useSelector, useDispatch } from 'react-redux'
import { setContactRegister } from 'api/contact';
import { useContactMutation } from "services/mail";
import { setContactUs } from 'api/session';

const ContactPopUp = (props) => {



    const register = useSelector(state => state.contact.register);
    const dispatch = useDispatch();
    const [comments, setComments] = useState('');

    const [loading, setLoading] = useState(false);
    const [disableButton, setDisableButton] = useState(true);
    const [contactus, { isLoading: isUpdating }] = useContactMutation();

    useEffect(() => {
        if (register.firstName.length > 0 && register.lastName.length > 0 && register.email.length > 0 && register.phone_number.length > 0) {
            setDisableButton(false)
        }
    }, [register, comments])

    const onFirstNameChange = (event) => {
        dispatch(setContactRegister({ firstName: event.target.value }))
    }

    const onDealersNameChange = (event) => {
        dispatch(setContactRegister({ dealerName: event.target.value }))
    }

    const onDealersAddressChange = (event) => {
        dispatch(setContactRegister({ dealerAddress: event.target.value }))
    }


    const onDealersZipCodeChange = (event) => {
        dispatch(setContactRegister({ dealerZipCode: event.target.value }))
    }

    const onDealersTypeChange = (event) => {
        dispatch(setContactRegister({ dealerType: event.target.value }));
    };

    const onLastNameChange = (event) => {
        dispatch(setContactRegister({ lastName: event.target.value }))
    }

    const onEmailChange = (event) => {
        dispatch(setContactRegister({ email: event.target.value }))
    }

    const onPhoneChange = (event) => {
        dispatch(setContactRegister({ phone: event.target.value }));
        dispatch(setContactRegister({ phone_number: `+1${event.target.value}` }));
    }

    const onComments = (event) => {
        setComments(event.target.value);
    }

    const sendMailFunction = () => {
        setLoading(true);
        setDisableButton(true);
        contactus({

            "from": {
                "module": "Tirefax",
                "title": "via Contact Us form - https://dealers.tirefax.com",
                "url": "https://dealers.tirefax.com"
            },
            "value": {
                "dealerName": register.dealerName,
                "dealerType": register.dealerType,
                "dealerAddress": register.dealerAddress,
                "dealerZipCode": register.dealerZipCode,
                "dealerState": register.dealerState,
                "dealerCity": register.dealerCity,
                "name": `${register.firstName} ${register.lastName}`,
                "zipCode": register.dealerZipCode,
                "email": register.email,
                "phone": register.phone_number,
                "comments": `Dealer Name: ${register.dealerName} and Dealer Type: ${register.dealerType}`
            }

        })
            .unwrap()
            .then(result => {
                dispatch(setContactUs(false));
                setDisableButton(false);
                setLoading(false)
            })
            .catch(err => {
                dispatch(setContactUs(false));
                setDisableButton(false);
                setLoading(false)
            })
    }

    return (
        <React.Fragment>
            <AppBar position="sticky" elevation={0}
                sx={{
                    background: "#56516b",
                    color: "#fff",
                    fontWeight: "bolder",
                    '&:hover': {
                        background: "#6a6485"
                    }
                }}
            >
                <Toolbar>
                    <Typography variant="h6"
                        sx={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#fff",
                            flexGrow: 1
                        }}
                    >For Dealers</Typography>
                    <Button
                        variant="contained"
                        sx={{
                            background: "#FE8200",
                            '&:hover': {
                                background: "#FE8200"
                            }
                        }}
                        onClick={() => {
                            dispatch(setContactUs(false));
                        }}
                    >Close</Button>
                </Toolbar>
            </AppBar>
            <Paper elevation={0} sx={{
                padding: "10px",
                minHeigth: "800px"
            }}>

                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="Company Name"
                    placeholder="Company Name"
                    name="dealerName"
                    onChange={onDealersNameChange}
                    value={register.dealerName || ''}
                />
                <FormControl fullWidth sx={{ marginTop: "10px" }}>
                    <InputLabel id="dealerType">Type of Company</InputLabel>
                    <Select
                        labelId="dealerType"
                        id="dealerType"
                        value={register.dealerType}
                        label="Type of Company"
                        onChange={onDealersTypeChange}
                    >

                        <MenuItem value={'Dealership'}>Dealership</MenuItem>
                        <MenuItem value={'Dealer Group'}>Dealer Group</MenuItem>
                        <MenuItem value={'Auto Service Retail'}>Auto Service Retail</MenuItem>
                        <MenuItem value={'Fleets'}>Fleets</MenuItem>
                        <MenuItem value={'Rental Agency'}>Rental Agency</MenuItem>
                        <MenuItem value={'Auctions'}>Auctions</MenuItem>

                    </Select>
                </FormControl>
                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="Company Address"
                    placeholder="Company Address"
                    name="dealerAddress"
                    onChange={onDealersAddressChange}
                    value={register.dealerAddress || ''}
                />
                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="Company's ZipCode"
                    placeholder="Company's ZipCode"
                    name="dealerZipCode"
                    onChange={onDealersZipCodeChange}
                    value={register.dealerZipCode || ''}
                />
                <Divider sx={{ margin: "20px" }} />
                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="First Name"
                    placeholder="Enter your first name"
                    name="firstName"
                    onChange={onFirstNameChange}
                    value={register.firstName || ''}
                />
                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="Last Name"
                    placeholder="Enter your last name"
                    name="lastName"
                    onChange={onLastNameChange}
                    value={register.lastName || ''}
                />
                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="Business E-Mail"
                    placeholder="Enter your business email address"
                    name="email"
                    onChange={onEmailChange}
                    value={register.email || ''}
                />
                <TextField
                    variant="outlined"
                    type="text"
                    fullWidth
                    margin="normal"
                    label="Phone"
                    placeholder="Enter your Phone Number"
                    name="phone"
                    onChange={onPhoneChange}
                    value={register.phone || ''}
                />

                <Button
                    color={"primary"}
                    sx={{
                        fontSize: "14px",
                        backgroundColor: "#ED6C02",
                        color: "#fff",
                        marginTop: "30px",
                        marginBottom: "10px",
                        "&:hover": {
                            backgroundColor: "#ED6C02",
                            color: "#fff"
                        },
                        "&:disabled": {
                            backgroundColor: "#939393de",
                            color: "#dfdcdcde"
                        }

                    }}
                    size={'large'}
                    fullWidth
                    onClick={(() => sendMailFunction())}
                    disabled={disableButton || loading}
                >
                    {loading ? 'Please Wait...' : 'Submit'}
                </Button>
            </Paper>
        </React.Fragment>

    )
}

export default ContactPopUp;